import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';

const CollapseButton = styled.span`
  ${({ theme: { typography } }) => typography.field()};
  color: ${({ theme: { color } }) => color.PLColor1};
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  margin-top: 12px;
`;

const MenuCollapse = styled(Collapse)`
  width: 100%;
  .MuiCollapse-wrapper {
    justify-content: center;
  }
`;

export { CollapseButton, MenuCollapse };
